var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTags(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "orders-icn",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28314",
    "data-name": "Rectangle 28314",
    className: "cls-1",
    width: 25,
    height: 25
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "orders-icn-2",
    "data-name": "orders-icn",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "price-tag",
    className: "cls-1",
    d: "M7.931,17.722h0a2.063,2.063,0,0,1-1.468-.609L.94,11.584a2.08,2.08,0,0,1,0-2.935L8.382,1.192A4.033,4.033,0,0,1,11.256,0h4.722a2.079,2.079,0,0,1,2.077,2.077V6.784a4.033,4.033,0,0,1-1.191,2.872L9.4,17.115A2.064,2.064,0,0,1,7.931,17.722ZM11.256,1.385a2.658,2.658,0,0,0-1.894.785L1.92,9.627a.693.693,0,0,0,0,.978l5.521,5.529a.687.687,0,0,0,.489.2h0a.688.688,0,0,0,.489-.2l7.466-7.458a2.658,2.658,0,0,0,.785-1.893V2.077a.693.693,0,0,0-.692-.692Zm1.78,5.642A2.077,2.077,0,1,1,15.113,4.95,2.079,2.079,0,0,1,13.036,7.027Zm0-2.769a.692.692,0,1,0,.692.692A.693.693,0,0,0,13.036,4.257Zm0,0",
    transform: "translate(3.666 4)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTags);
export default __webpack_public_path__ + "static/media/tags.e709b8f1c375d25ad2e686930cbc04a4.svg";
export { ForwardRef as ReactComponent };